import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import { getIn } from 'formik';
import { injectIntl } from 'react-intl';
import { SrLabel } from '~helpers';
import Container from './Container';
import FormInputBar from './input/FormInputBar';
import FormInputFeedback from './feedback/FormInputFeedback';
import Select from './select/Select';
import FormSelectLabel from './select/FormSelectLabel';
import FormSelectOption from './select/FormSelectOption';
import formPropTypes from '../prop-types/formPropTypes';

var FormSelect = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FormSelect, _Component);

  function FormSelect(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function (event) {
      var field = _this.props.field;

      _this.setState({
        focused: false
      });

      field.onBlur(event);
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          field = _this$props.field,
          onChange = _this$props.onChange;

      _this.setState({
        selected: !!event.target.value
      });

      field.onChange(event);

      if (onChange) {
        onChange(event);
      }
    };

    _this.state = {
      focused: false,
      selected: false
    };
    return _this;
  }

  var _proto = FormSelect.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        intl = _this$props2.intl,
        id = _this$props2.id,
        form = _this$props2.form,
        field = _this$props2.field,
        options = _this$props2.options,
        translateOptionsLabel = _this$props2.translateOptionsLabel,
        label = _this$props2.label,
        disabled = _this$props2.disabled,
        required = _this$props2.required,
        hideLabel = _this$props2.hideLabel,
        skin = _this$props2.skin;
    var _this$state = this.state,
        focused = _this$state.focused,
        selected = _this$state.selected;
    var error = getIn(form.errors, field.name);
    var touch = getIn(form.touched, field.name);
    var value = getIn(form.values, field.name);
    var isSubmitted = form.submitCount > 0;
    var selectOptions = options.map(function (option) {
      var selectLabel = translateOptionsLabel ? intl.formatMessage({
        id: option.label
      }) : option.label;
      return /*#__PURE__*/React.createElement(FormSelectOption, {
        key: option.value,
        value: option.value || '',
        disabled: option.disabled,
        skin: skin
      }, selectLabel);
    });
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SrLabel, {
      htmlFor: id
    }, label), /*#__PURE__*/React.createElement(Select, {
      value: value,
      id: id,
      name: field.name,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      disabled: disabled,
      skin: skin,
      selected: selected,
      hideLabel: hideLabel
    }, selectOptions), !hideLabel && /*#__PURE__*/React.createElement(FormSelectLabel, {
      required: required,
      focused: focused,
      selected: selected,
      "aria-hidden": "true",
      skin: skin,
      error: error,
      isSubmitted: isSubmitted
    }, label), /*#__PURE__*/React.createElement(FormInputBar, {
      active: focused,
      skin: skin,
      error: error,
      isSubmitted: isSubmitted
    }), error && (touch || isSubmitted) && /*#__PURE__*/React.createElement(FormInputFeedback, {
      feedbackType: "error",
      id: id,
      message: error,
      skin: skin
    }));
  };

  return FormSelect;
}(Component);

FormSelect.defaultProps = {
  hideLabel: false,
  required: false,
  disabled: false,
  translateOptionsLabel: true,
  skin: 'dark',
  onChange: null
};
export default injectIntl(FormSelect);